"use strict";

function initSolarLeadFormAlternateAddress() {
	const solarLeadForm = '.js-solar-lead-form',
		solarLeadFormLabel = '.js-trigger-alternate-address',
		elementSolarLeadForm = document.querySelector(solarLeadForm);

	if (elementSolarLeadForm) {

		const alternateAddressFieldInput = document.querySelector('.js-address-autocomplete[data-autocomplete="addressAlternate"]'),
			elementAlternateAddressLabel = elementSolarLeadForm.querySelector(solarLeadFormLabel);

		let checkboxValue = true;

		if (alternateAddressFieldInput && alternateAddressFieldInput.value !== '') {
			checkboxValue = false;
			toggleAlternateAddressVisibility(alternateAddressFieldInput, checkboxValue);
		}

		if (elementAlternateAddressLabel) {
			elementAlternateAddressLabel.addEventListener('change', function () {
				const checkboxValue = elementAlternateAddressLabel.checked;
				toggleAlternateAddressVisibility(alternateAddressFieldInput, checkboxValue);
			})
		}

	}

}

function toggleAlternateAddressVisibility(alternateAddressFieldInput, checkboxValue) {
	const alternateAddressField = alternateAddressFieldInput.closest('.js-form-personal-data').querySelector('.js-alternate-address');

	if (checkboxValue) {
		alternateAddressField.classList.add('is-hidden');
		alternateAddressFieldInput.classList.remove('is-invalid');
		alternateAddressFieldInput.closest('.js-solar-lead-field').classList.remove('is-invalid');
		alternateAddressFieldInput.value = '';
		alternateAddressFieldInput.removeAttribute("required");
	} else {
		alternateAddressField.classList.remove('is-hidden');
		alternateAddressFieldInput.setAttribute("required", "required");
	}
}

document.addEventListener("DOMContentLoaded", function () {
	initSolarLeadFormAlternateAddress();
});
